/**
 * @ngdoc directive
 * @name segmentBar
 * @param matchmedia
 * @param breakpoints
 * @param EcourseFactory
 * @param $timeout
 * @returns {{restrict: string, templateUrl: string, scope: {slug: string, segments: string}, link: Function}}
 */
let scrollPos = 0;
export default function segmentBar(matchmedia, breakpoints, EcourseFactory, $timeout) {
  'ngInject';
  //Runtime cache for position of scroll
  return {
    restrict: 'E',
    templateUrl: 'app/ecourse/shared/segmentBar/segmentBar.html',
    scope: {
      slug: '=',
      segments: '=',
    },
    compile: function ($element) {
      //Cache selectors
      let realElement = $element[0],
        inner = realElement.querySelector('.segment-bar');
      inner.scrollLeft = scrollPos;
      return {
        post: function ($scope, $element) {
          //After a digest cycle get the active element
          $timeout(function () {
            //Find active segment link
            let active = realElement.querySelector('.segment.active');
            //If we have an active segment
            if (active) {
              //Scroll the segment-bar to show the active segment element
              scrollPos = active.offsetLeft - active.offsetWidth;
              inner.scrollLeft = scrollPos;
              $scope.moved = scrollPos;
            }
          });

          //Toggle the mobile dropdown list open state
          function toggleOpen() {
            //TODO - Let angular know.
            inner.classList.toggle('open');
          }

          function move(direction = 1) {
            let step = inner.clientWidth / ($scope.segments.length + 1);//Get the current width of the item which could change at any time due to browser size changes.
            if (direction < 0) {
              $scope.moved = Math.max(0,$scope.moved - step);
            }
            else {
              $scope.moved = Math.min($scope.moved + step, inner.scrollWidth - inner.clientWidth);
            }
            setOffset(inner, $scope.moved);
          }

          function setOffset(elem, amount) {
            TweenLite.to(elem, 1, {scrollLeft: amount, ease: Power4.easeOut});
          }

          //When small we want the dropdown list to show.
          matchmedia.on(breakpoints.small, function (list) {
            if (list.matches) {
              //Init the dropdown list.
              $scope.small = true;
              $element.on('click', toggleOpen);
              $scope.showArrows = false;
            }
          });

          //When on medium or above we want to remove the dropdown
          matchmedia.on(breakpoints.mediumStart, function (list) {
            if (list.matches) {
              //Break down the dropdown list.
              inner.classList.remove('open');
              $scope.small = false;
              $element.off('click', toggleOpen);

            }
          });

          //When on only medium we want to display the arrows
          matchmedia.on(breakpoints.medium, function (list) {
            if (list.matches) {
              $scope.showArrows = $scope.segments.length > 2;
            }
          });

          matchmedia.on(breakpoints.largeStart, function (list) {
            if (list.matches) {
              $scope.showArrows = $scope.segments.length > 5;
            }
          });


          //Lift function from the factory and expose it to the template
          $scope.available = EcourseFactory.segmentAvailable;
          $scope.moved = 0;
          $scope.move = move;
        }
      };
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/shared/segmentBar/segmentBar.directive.js
 **/